"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const useOnOutsideClick_1 = require("../../../../../Hooks/useOnOutsideClick");
const ModalCard = ({ closeModal, image }) => {
    const containerRef = (0, react_1.useRef)(null);
    (0, useOnOutsideClick_1.useOnOutsideClick)(containerRef, () => {
        closeModal();
    });
    const crossCloseModal = (e) => {
        e.stopPropagation();
        closeModal();
    };
    return (react_1.default.createElement(styled.Container, null,
        react_1.default.createElement(styled.InnerContainer, { col: 12, sm: 10, md: 8, ref: containerRef, image: image },
            react_1.default.createElement(styled.CrossIcon, { onClick: (e) => crossCloseModal(e) }))));
};
exports.default = ModalCard;
